<ng-container *transloco="let t;">
  <app-list-view [title]="t('common.labels.rooms')" [messages]="messages" [loading]="loading">

    <div buttons>
      <button withRight="admin.room.list" pButton (click)="onReload()" type="button" icon="pi pi-refresh" class="p-button-secondary p-button-outlined p-mb-2" aria-label="{{ t('common.labels.reload_list') }}" pTooltip="{{ t('common.labels.reload_list') }}" tooltipPosition="left"></button>
      <button withRight="admin.room.create" pButton (click)="onNew()" type="button" icon="pi pi-plus" label="{{ t('common.labels.new') }}" class="p-button-success p-ml-2 p-mb-2"></button>
    </div>

    <div table>
      <p-table
        [value]="rooms"
        [paginator]="true"
        [rows]="20"
        stateStorage="local"
        stateKey="room-list"
        [rowsPerPageOptions]="rowsPerPage"
        [showCurrentPageReport]="true"
        [currentPageReportTemplate]="t('common.labels.current_page_report')"
      >
        <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="active">{{ t('common.labels.active') }}
                  <p-sortIcon field="active"></p-sortIcon>
              </th>
              <th pSortableColumn="name">{{ t('common.labels.name') }}
                  <p-sortIcon field="name"></p-sortIcon>
              </th>
              <th pSortableColumn="type">{{ t('common.labels.type') }}
                  <p-sortIcon field="type"></p-sortIcon>
              </th>
              <th pSortableColumn="city">{{ t('common.labels.city') }}
                  <p-sortIcon field="city"></p-sortIcon>
              </th>
              <th pSortableColumn="capacity">{{ t('common.labels.capacity') }}
                  <p-sortIcon field="capacity"></p-sortIcon>
              </th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-room>
            <tr (click)="onOpen(room)" (keyup.enter)="onOpen(room)" hoverOnRight="admin.room.show" tabindex="0">
              <td><span role="link"><i class="pi pi-ban" [ngClass]="{'pi-check': room.active === true}"></i></span></td>
              <td><span role="link">{{ room.name }}</span></td>
              <td><span role="link">{{ transloco.translate(roomTypes[room.type]) }}</span></td>
              <td><span role="link">{{ room.city }}</span></td>
              <td><span role="link">{{ room.capacity }}</span></td>
            </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td class="no-data" colspan="4">{{ t('common.labels.no_data') }}</td>
          </tr>
        </ng-template>
      </p-table>
    </div>

  </app-list-view>
</ng-container>
